import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTasklist = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.3364 8.7364C18.6879 8.38492 18.6879 7.81508 18.3364 7.4636C17.9849 7.11213 17.4151 7.11213 17.0636 7.4636L9.9 14.6272L6.9364 11.6636C6.58492 11.3121 6.01508 11.3121 5.6636 11.6636C5.31213 12.0151 5.31213 12.5849 5.6636 12.9364L9.2636 16.5364C9.61508 16.8879 10.1849 16.8879 10.5364 16.5364L18.3364 8.7364Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.1 0C0.940201 0 0 0.940203 0 2.1V21.9C0 23.0598 0.940203 24 2.1 24H21.9C23.0598 24 24 23.0598 24 21.9V2.1C24 0.940201 23.0598 0 21.9 0H2.1ZM1.8 2.1C1.8 1.93431 1.93432 1.8 2.1 1.8H21.9C22.0657 1.8 22.2 1.93432 22.2 2.1V21.9C22.2 22.0657 22.0657 22.2 21.9 22.2H2.1C1.93431 22.2 1.8 22.0657 1.8 21.9V2.1Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgTasklist;
